import script from "./safeguardTime.vue?vue&type=script&setup=true&lang=js"
export * from "./safeguardTime.vue?vue&type=script&setup=true&lang=js"

import "./safeguardTime.vue?vue&type=style&index=0&id=7651b50e&lang=scss&scoped=true"
import "./safeguardTime.vue?vue&type=style&index=1&id=7651b50e&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7651b50e"]])

export default __exports__